import React, { useState, useContext } from 'react'
import { Link, useHistory } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { useSelector } from 'react-redux';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import LightBox from 'components/LightBox';
import { GlobalContext } from 'store/context/GlobalContext';
import { addSerial } from 'services/authService';
import {isMobile} from 'react-device-detect';
import useGa from 'hooks/useGa';
import useFbq from 'hooks/useFbq';
import { AttrText } from 'components/AttrText';

export default function Exchange() {
    const gaTracking = useGa();
    const fbqTracking = useFbq();
    const history = useHistory();
    const user = useSelector((state) => state.Auth.user);
    const context = useContext(GlobalContext);
    const { userData, setUserData, setSnack, setLoader } = context;
    const [ checkboxToggle, setCheckboxToggle ] = useState(false);
    const { handleSubmit, reset, formState: { isDirty, isValid, errors }, register } = useForm({ mode: 'onBlur', shouldUnregister: true });
    const [ exchangeSuccessLightbox, setExchangeSuccessLightbox ] = useState(false);
    const [ exchangeErrorLightbox, setExchangeErrorLightbox ] = useState(false);
    const [ inputLightbox, setInputLightbox ] = useState(false);
    const [ checkboxLightbox, setCheckboxLightbox ] = useState(false);
    const [ inputCountErrorLightbox, setInputCountErrorLightbox ] = useState(false);
    const [ serialStatus, setSerialStatus ] = useState([0,0,0,0,0,0]);
    const [ inputCountError, setInputCountError ] = useState([0,0,0,0,0,0]);

    const onSubmit = (data) => {
        gaTracking("codeRegistered-submit");
        fbqTracking('trackCustom', 'sendserial');
        fbqTracking('track', 'InitiateCheckout');
        if(data.serial.filter(e => e).length < 1){
            setInputLightbox(true);
            return;
        }

        if(inputCountError.findIndex(e => e === 1) > -1){
            setInputCountErrorLightbox(true);
            return;
        }

        if(!checkboxToggle){
            setCheckboxLightbox(true);
            return;
        }

        let result = {
            login_id: user.login_id,
            event_id: userData.event_id,
            device: isMobile ? "m" : "pc",
            ...data,
        }

        const formData = new FormData();
        Object.keys(result).map(function(key) {
            if(Array.isArray(result[key])){
                for(let i = 0; i< result[key].length; i++){
                    formData.append(`${key}[${i}]`,result[key][i]);
                }
            }else{
                return formData.append(key, result[key]);
            }
        });

        setLoader(true);
        addSerial(formData).then(res => {
            setTimeout(() => {
                if(res.result){
                    setLoader(false);
                    setExchangeSuccessLightbox(true);
                    setUserData({
                        ...userData,
                        serial_list: res.serial_list,
                        user_last_points: res.user_last_points,
                        user_points: res.user_points,
                        user_used_points: res.user_used_points
                    })
                    reset({
                        'serial[0]': '',
                        'serial[1]': '',
                        'serial[2]': '',
                        'serial[3]': '',
                        'serial[4]': '',
                        'serial[5]': '',
                    });
                    setSerialStatus(0,0,0,0,0,0);
                }else{
                    if(res.end){
                        setLoader(false);
                        alert(res.msg);
                        return;
                    }else{
                        setLoader(false);
                        setExchangeErrorLightbox(true);
                        setSerialStatus(res.serial_ck);
                    }
                }
            }, 500)
        })
    }

    const handleChange = (index, value) => {
        let obj = {};
        let arr = Array.from(inputCountError);
        if(value === ""){
            let result = Array.from(serialStatus);
            result[index] = 0;
            arr[index] = 0;
            setSerialStatus(result);
            setInputCountError(arr);
        }else{
            obj[`serial[${index}]`] = value.replace(/[^\a-\z\A-\Z\d\@\#]/g,'').toUpperCase();
            reset(obj);
            if(obj[`serial[${index}]`].length > 0 && obj[`serial[${index}]`].length !== 6 && obj[`serial[${index}]`].length !== 8){
                arr[index] = 1;
            }else{
                arr[index] = 0;
            }
            setInputCountError(arr);
        }
    }

    return (<>
        <div className="inner-bg"></div>
        <div className="inner-page exchange-page">
            <div className="inner-container">
                <AttrText className="name" text={user.login_name}>{user.login_name}</AttrText>
                <div className="fw-bold pdy-3">
                    <div>請於下方輸入瓶貼序號，每1張瓶貼序號代表1點，亦有機會隨機出現2點、5點或10點。</div>
                    <div>兌換結果可於「我的序號」&gt;「登錄序號明細」中查看。</div>
                </div>
                <form onSubmit={handleSubmit(onSubmit)} className="exchange-form">
                    <div className="exchange-form-group">
                        <div className="count">1</div>
                        <input
                            style={{imeMode: "disabled"}}
                            tabIndex="1"
                            name="serial[0]"
                            type="text"
                            autoComplete="off"
                            spellCheck="false"
                            placeholder="請輸入序號"
                            maxLength="8"
                            {...register("serial[0]")}
                            onChange={(e) => handleChange(0, e.target.value)}
                        />
                        <i className={`far fa-times-circle${serialStatus[0] === 2 ? ' active' : ''}`}></i>
                    </div>
                    { inputCountError[0] === 1 && <div className="font-size-14 text-danger text-left mgt-1 mgb-4" style={{marginLeft: "50px"}}>* 序號必須為6或8個字元</div> }
                    <div className="exchange-form-group">
                        <div className="count">2</div>
                        <input
                            tabIndex="1"
                            name="serial[1]"
                            type="text"
                            autoComplete="off"
                            spellCheck="false"
                            placeholder="請輸入序號"
                            maxLength="8"
                            {...register("serial[1]")}
                            onChange={(e) => handleChange(1, e.target.value)}
                        />
                        <i className={`far fa-times-circle${serialStatus[1] === 2 ? ' active' : ''}`}></i>
                    </div>
                    { inputCountError[1] === 1 && <div className="font-size-14 text-danger text-left mgt-1 mgb-4" style={{marginLeft: "50px"}}>* 序號必須為6或8個字元</div> }
                    <div className="exchange-form-group">
                        <div className="count">3</div>
                        <input
                            tabIndex="1"
                            name="serial[2]"
                            type="text"
                            autoComplete="off"
                            spellCheck="false"
                            placeholder="請輸入序號"
                            maxLength="8"
                            {...register("serial[2]")}
                            onChange={(e) => handleChange(2, e.target.value)}
                        />
                        <i className={`far fa-times-circle${serialStatus[2] === 2 ? ' active' : ''}`}></i>
                    </div>
                    { inputCountError[2] === 1 && <div className="font-size-14 text-danger text-left mgt-1 mgb-4" style={{marginLeft: "50px"}}>* 序號必須為6或8個字元</div> }
                    <div className="exchange-form-group">
                        <div className="count">4</div>
                        <input
                            tabIndex="1"
                            name="serial[3]"
                            type="text"
                            autoComplete="off"
                            spellCheck="false"
                            placeholder="請輸入序號"
                            maxLength="8"
                            {...register("serial[3]")}
                            onChange={(e) => handleChange(3, e.target.value)}
                        />
                        <i className={`far fa-times-circle${serialStatus[3] === 2 ? ' active' : ''}`}></i>
                    </div>
                    { inputCountError[3] === 1 && <div className="font-size-14 text-danger text-left mgt-1 mgb-4" style={{marginLeft: "50px"}}>* 序號必須為6或8個字元</div> }
                    <div className="exchange-form-group">
                        <div className="count">5</div>
                        <input
                            tabIndex="1"
                            name="serial[4]"
                            type="text"
                            autoComplete="off"
                            spellCheck="false"
                            placeholder="請輸入序號"
                            maxLength="8"
                            {...register("serial[4]")}
                            onChange={(e) => handleChange(4, e.target.value)}
                        />
                        <i className={`far fa-times-circle${serialStatus[4] === 2 ? ' active' : ''}`}></i>
                    </div>
                    { inputCountError[4] === 1 && <div className="font-size-14 text-danger text-left mgt-1 mgb-4" style={{marginLeft: "50px"}}>* 序號必須為6或8個字元</div> }
                    <div className="exchange-form-group">
                        <div className="count">6</div>
                        <input
                            tabIndex="1"
                            name="serial[5]"
                            type="text"
                            autoComplete="off"
                            spellCheck="false"
                            placeholder="請輸入序號"
                            maxLength="8"
                            {...register("serial[5]")}
                            onChange={(e) => handleChange(5, e.target.value)}
                        />
                        <i className={`far fa-times-circle${serialStatus[5] === 2 ? ' active' : ''}`}></i>
                    </div>
                    { inputCountError[5] === 1 && <div className="font-size-14 text-danger text-left mgt-1 mgb-4" style={{marginLeft: "50px"}}>* 序號必須為6或8個字元</div> }
                    <div className="mgt-4 mgb-3">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name="agree"
                                    size="small"
                                    checked={checkboxToggle}
                                    value="checked"
                                    onChange={() => setCheckboxToggle(!checkboxToggle)}
                                />
                            }
                            label={
                                <div className="font-size-14 font-family-notosans">
                                    我已閱讀並同意<Link to="/activity" target="_blank" className="text-decoration-underline fw-bold">活動辦法及隱私權規範</Link>
                                </div>
                            }
                            sx={{margin: "0 0 0 -10px"}}
                        />
                    </div>
                    <div>
                        <button type="submit" className="common-btn yellow">確認送出</button>
                    </div>
                </form>
            </div>
            <LightBox
                open={exchangeSuccessLightbox}
                callback={() => setExchangeSuccessLightbox(false)}
                cross
            >
                <div className="light-box-header exchange-success"></div>
                <div className="light-box-body text-center">
                    <div className="text">
                        <div>請保留已登錄序號之瓶貼紙本，</div>
                        <div>以供備查。</div>
                    </div>
                    <button
                        type="button"
                        className="common-btn yellow mgb-8"
                        onClick={() => {
                            gaTracking("codeRegistered-submit-success");
                            setExchangeSuccessLightbox(false);
                            setTimeout(() => {
                                history.push("/serial-number#exchange");
                            }, 0)
                        }}
                    >
                        我的序號
                    </button>
                </div>
            </LightBox>

            <LightBox
                open={inputCountErrorLightbox}
                callback={() => setInputCountErrorLightbox(false)}
                className="custom-light-box"
                cross
            >
                <div className="light-box-body text-center">
                    <div className="text">
                        <div>序號必須為6或8個字元</div>
                    </div>
                    <button
                        type="button"
                        className="common-btn yellow mgb-8"
                        onClick={() => {
                            gaTracking("codeRegistered-length-error");
                            setInputCountErrorLightbox(false);
                        }}
                    >
                        確認
                    </button>
                </div>
            </LightBox>

            <LightBox
                open={exchangeErrorLightbox}
                callback={() => setExchangeErrorLightbox(false)}
                cross
            >
                <div className="light-box-header exchange-error"></div>
                <div className="light-box-body text-center">
                    <div className="text">
                        <div>您的序號輸入錯誤，或重複輸入相同序號，請重新確認。</div>
                    </div>
                    <button
                        type="button"
                        className="common-btn yellow mgb-8"
                        onClick={() => {
                            gaTracking("codeRegistered-value-error");
                            setExchangeErrorLightbox(false);
                        }}
                    >
                        重新輸入
                    </button>
                </div>
            </LightBox>

            <LightBox
                open={inputLightbox}
                callback={() => setInputLightbox(false)}
                className="custom-light-box"
                cross
            >
                <div className="light-box-body text-center">
                    <div className="text">
                        <div>請先輸入序號</div>
                    </div>
                    <button
                        type="button"
                        className="common-btn yellow mgb-8"
                        onClick={() => {
                            gaTracking("codeRegistered-required-error");
                            setInputLightbox(false);
                        }}
                    >
                        確認
                    </button>
                </div>
            </LightBox>

            <LightBox
                open={checkboxLightbox}
                callback={() => setCheckboxLightbox(false)}
                className="custom-light-box"
                cross
            >
                <div className="light-box-body text-center">
                    <div className="text">
                        <div>請閱讀並勾選活動辦法及隱私權規範</div>
                    </div>
                    <button
                        type="button"
                        className="common-btn yellow mgb-8"
                        onClick={() => {
                            gaTracking("codeRegistered-agree-error");
                            setCheckboxLightbox(false);
                        }}
                    >
                        確認
                    </button>
                </div>
            </LightBox>
        </div>
    </>)
}
